/** d3/VisX: 0 at 12 o'clock; π/2 rotates first slice to 3 o'clock (Figma / Recharts parity). */
export const ChartPieConstants = {
  d3StartAngle: Math.PI / 2,
  d3EndAngle: Math.PI / 2 + Math.PI * 2,
  /** Full pie — no inner hole. */
  pieInnerRadius: 0,
  pieOuterRadius: 130,
  /** Donut inner hole (Figma Port-to-Port carrier donut). */
  donutInnerRadius: 90,
  donutOuterRadius: 130,
  defaultDiameter: 300,
  defaultOtherThresholdPct: 2,
  defaultMinLabelPct: 5,
  percentLabelOffset: 16,
  labelMargin: 24,
  /** No slice ring by default — seams read from adjacent fills. */
  sliceStrokeWidth: 0,
  legendDotSizePx: 19,
  legendDotBorder: '2px solid #FFFFFF',
  legendDotShadow: '0 1px 2px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.08)',
  minLegendGapPx: 40,
  maxLegendGapPx: 100,
  defaultCenterTotalCaption: 'Total',
  defaultShowCenterTotal: false,
  defaultIsDonut: true,
} as const
